'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Daterange;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Daterange(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M9.33333333,11.1002024 L7.55533333,11.1002024 L7.55533333,12.8997974 L9.33333333,12.8997974 L9.33333333,11.1002024 Z M12.8886667,11.1002024 L11.1113333,11.1002024 L11.1113333,12.8997974 L12.8886667,12.8997974 L12.8886667,11.1002024 Z M16.4446667,11.1002024 L14.6666667,11.1002024 L14.6666667,12.8997974 L16.4446667,12.8997974 L16.4446667,11.1002024 Z M18.222,4.79959498 L17.3333333,4.79959498 L17.3333333,3 L15.5553333,3 L15.5553333,4.79959498 L8.44466667,4.79959498 L8.44466667,3 L6.66666667,3 L6.66666667,4.79959498 L5.778,4.79959498 C4.79133333,4.79959498 4.00866667,5.60961522 4.00866667,6.59986497 L4,19.2004049 C3.99999997,19.6778041 4.1873457,20.1356405 4.52080456,20.4731494 C4.85426342,20.8106584 5.3065064,21.0001789 5.778,20.9999999 L18.222,20.9999999 C19.2,20.9999999 20,20.1899796 20,19.2004049 L20,6.59986497 C20,5.60961522 19.2,4.79959498 18.222,4.79959498 Z M18.222,19.2004049 L5.778,19.2004049 L5.778,9.29993245 L18.222,9.29993245 L18.222,19.2004049 L18.222,19.2004049 Z'
  }));
}
Daterange.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};